module.exports = __webpack_public_path__ + "img/refer-client.98c45531.svg";